import React, { lazy, useMemo } from 'react';
import PropTypes from 'prop-types';
import trans from 'translate';
import { Route, Switch } from 'react-router-dom';
import AccountRouteChecker from '../../AccountRouteChecker/AccountRouteChecker';
import PortfolioNftRedirect from './PortfolioNft/PortfolioNftRedirect';

const PortfolioLazy = lazy(() => import('./Portfolio'));
const PortfolioNftLazy = lazy(() => import('./PortfolioNft/PortfolioNft'));

const PortfolioRoutes = ({ match }) => {
  const portfolioNftTitle = useMemo(
    () => [{ title: trans('portfolio.my_portfolio'), route: match.path }, { title: trans('portfolio.nft_ticket') }],
    [match],
  );

  return (
    <Switch>
      <AccountRouteChecker
        exact
        path={match.path}
        requireLogin
        blockerPageTitle={trans('portfolio.my_portfolio')}
        component={PortfolioLazy}
      />

      <Route exact path={`${match.path}/nft`} component={PortfolioNftRedirect} />
      <AccountRouteChecker
        path={`${match.path}/nft/:id`}
        requireLogin
        additional={{ title: portfolioNftTitle }}
        blockerPageTitle={portfolioNftTitle}
        component={PortfolioNftLazy}
      />
    </Switch>
  );
};

PortfolioRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default PortfolioRoutes;
